module.exports = __webpack_public_path__ + "img/face-emoticon1.15d0e654.svg";